export default __webpack_public_path__ + "static/media/FlyingOnTheWall.5cc16b9983795d023c7b1d0dfc9b74cf.webp";